/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreatePartnerRequest } from '../model';
// @ts-ignore
import { CreatePendingPartnerRequest } from '../model';
// @ts-ignore
import { PartnerBriefResponse } from '../model';
/**
 * AdminPartnerControllerApi - axios parameter creator
 * @export
 */
export const AdminPartnerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner: async (createPartnerRequest: CreatePartnerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartnerRequest' is not null or undefined
            assertParamExists('createPartner', 'createPartnerRequest', createPartnerRequest)
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePendingPartnerRequest} createPendingPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPendingPartner: async (createPendingPartnerRequest: CreatePendingPartnerRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPendingPartnerRequest' is not null or undefined
            assertParamExists('createPendingPartner', 'createPendingPartnerRequest', createPendingPartnerRequest)
            const localVarPath = `/admin/partners/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPendingPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefHubs: async (hubId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hubId' is not null or undefined
            assertParamExists('listBriefHubs', 'hubId', hubId)
            const localVarPath = `/admin/hubs/{hubId}/partners/brief`
                .replace(`{${"hubId"}}`, encodeURIComponent(String(hubId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerChannels: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/partner/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPartnerControllerApi - functional programming interface
 * @export
 */
export const AdminPartnerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPartnerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartner(createPartnerRequest: CreatePartnerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartner(createPartnerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreatePendingPartnerRequest} createPendingPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPendingPartner(createPendingPartnerRequest: CreatePendingPartnerRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPendingPartner(createPendingPartnerRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBriefHubs(hubId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBriefHubs(hubId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPartnerChannels(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPartnerChannels(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminPartnerControllerApi - factory interface
 * @export
 */
export const AdminPartnerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPartnerControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartner(createPartnerRequest: CreatePartnerRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createPartner(createPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePendingPartnerRequest} createPendingPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPendingPartner(createPendingPartnerRequest: CreatePendingPartnerRequest, options?: any): AxiosPromise<void> {
            return localVarFp.createPendingPartner(createPendingPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hubId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefHubs(hubId: string, options?: any): AxiosPromise<Array<PartnerBriefResponse>> {
            return localVarFp.listBriefHubs(hubId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPartnerChannels(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.listPartnerChannels(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPartnerControllerApi - object-oriented interface
 * @export
 * @class AdminPartnerControllerApi
 * @extends {BaseAPI}
 */
export class AdminPartnerControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreatePartnerRequest} createPartnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerControllerApi
     */
    public createPartner(createPartnerRequest: CreatePartnerRequest, options?: AxiosRequestConfig) {
        return AdminPartnerControllerApiFp(this.configuration).createPartner(createPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePendingPartnerRequest} createPendingPartnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerControllerApi
     */
    public createPendingPartner(createPendingPartnerRequest: CreatePendingPartnerRequest, options?: AxiosRequestConfig) {
        return AdminPartnerControllerApiFp(this.configuration).createPendingPartner(createPendingPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} hubId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerControllerApi
     */
    public listBriefHubs(hubId: string, options?: AxiosRequestConfig) {
        return AdminPartnerControllerApiFp(this.configuration).listBriefHubs(hubId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerControllerApi
     */
    public listPartnerChannels(options?: AxiosRequestConfig) {
        return AdminPartnerControllerApiFp(this.configuration).listPartnerChannels(options).then((request) => request(this.axios, this.basePath));
    }
}

